/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { ChallengeCategoryWithParticipationDto } from './challenge-category-with-participation-dto';

/**
 * 
 * @export
 * @interface GetChallengeByIdResponseDto
 */
export interface GetChallengeByIdResponseDto {
    /**
     * Unique identifier
     * @type {string}
     * @memberof GetChallengeByIdResponseDto
     */
    'id': string;
    /**
     * Creation date in UTC
     * @type {string}
     * @memberof GetChallengeByIdResponseDto
     */
    'createdAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof GetChallengeByIdResponseDto
     */
    'updatedAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof GetChallengeByIdResponseDto
     */
    'deletedAt': string;
    /**
     * Title of the challenge
     * @type {string}
     * @memberof GetChallengeByIdResponseDto
     */
    'title': string;
    /**
     * Detailed description of the challenge
     * @type {string}
     * @memberof GetChallengeByIdResponseDto
     */
    'description': string;
    /**
     * Promotional description of the challenge for marketing purposes
     * @type {string}
     * @memberof GetChallengeByIdResponseDto
     */
    'promotionalDescription'?: string | null;
    /**
     * ID of the organizer
     * @type {string}
     * @memberof GetChallengeByIdResponseDto
     */
    'organizerId': string;
    /**
     * Whether the challenge is active
     * @type {boolean}
     * @memberof GetChallengeByIdResponseDto
     */
    'isActive': boolean;
    /**
     * Whether the challenge should be promoted/featured
     * @type {boolean}
     * @memberof GetChallengeByIdResponseDto
     */
    'shouldPromote': boolean;
    /**
     * URL of the cover image
     * @type {string}
     * @memberof GetChallengeByIdResponseDto
     */
    'coverImageUrl': string;
    /**
     * Array of other image URLs
     * @type {Array<string>}
     * @memberof GetChallengeByIdResponseDto
     */
    'otherImagesUrl': Array<string>;
    /**
     * Challenge start date and time in UTC
     * @type {string}
     * @memberof GetChallengeByIdResponseDto
     */
    'startsAt': string;
    /**
     * Challenge end date and time in UTC
     * @type {string}
     * @memberof GetChallengeByIdResponseDto
     */
    'endsAt': string;
    /**
     * Array of challenge category options
     * @type {Array<ChallengeCategoryWithParticipationDto>}
     * @memberof GetChallengeByIdResponseDto
     */
    'challengeCategories': Array<ChallengeCategoryWithParticipationDto>;
    /**
     * Challenge status derived from dates and isActive flag
     * @type {string}
     * @memberof GetChallengeByIdResponseDto
     */
    'challengeStatus': GetChallengeByIdResponseDtoChallengeStatusEnum;
}

export const GetChallengeByIdResponseDtoChallengeStatusEnum = {
    NotStarted: 'not_started',
    Ongoing: 'ongoing',
    Ended: 'ended',
    Cancelled: 'cancelled'
} as const;

export type GetChallengeByIdResponseDtoChallengeStatusEnum = typeof GetChallengeByIdResponseDtoChallengeStatusEnum[keyof typeof GetChallengeByIdResponseDtoChallengeStatusEnum];


